import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../config/api';
import {
  isPartnerClientBrand,
  persistClientSessionBranding,
  useSyncClientBranding,
} from '../contexts/ClientBrandingContext';
import { getClientInviteToken, getTripInviteId } from '../utils/clientInvite';

const useClientInvitePreview = () => {
  const location = useLocation();
  const token = getClientInviteToken(location.search);
  const tripInviteId = getTripInviteId(location.search);
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    if (!token && !tripInviteId) {
      setBranding(null);
      return undefined;
    }
    let cancelled = false;
    const request = token
      ? api.get(`/auth/client-invite/${encodeURIComponent(token)}`)
      : api.get(`/auth/trip-invite/${encodeURIComponent(tripInviteId)}`);
    request.then((response) => {
      if (!cancelled) setBranding(response.data?.branding || null);
    }).catch(() => {
      if (!cancelled) setBranding(null);
    });
    return () => { cancelled = true; };
  }, [token, tripInviteId]);

  useSyncClientBranding(branding);

  useEffect(() => {
    if (isPartnerClientBrand(branding)) {
      persistClientSessionBranding(branding);
    }
  }, [branding]);

  return { token, branding };
};

export default useClientInvitePreview;
